import { useState } from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import Reveal from '../../home-new/Reveal'
import styles from './AwardsSection.module.scss'

// "รางวัลและความสำเร็จของ SHIPPOP" — same rewardsData/i18n the old about page
// used (see AboutNew.js), restyled as cards with a read-more/read-less toggle
// and a "ดูความสำเร็จทั้งหมด" reveal. Styling migrated from makeStyles to a
// static CSS Module.
const YEAR_RE = /(19|20)\d{2}|25\d{2}/

const getYear = (reward) => {
  const match = `${reward.title} ${reward.desc}`.match(YEAR_RE)
  return match ? match[0] : null
}

const AwardCard = ({ reward, t }) => {
  const [isTruncated, setTruncated] = useState(true)
  const year = getYear(reward)

  return (
    <div className={styles.card}>
      <div className={styles.cardImgWrap}>
        <img
          src={`/static/img/about-us/rewards/${reward.img}`}
          alt={reward.title}
          className={styles.cardImg}
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className={styles.cardBody}>
        <h3 className={styles.cardTitle}>{reward.title}</h3>
        {year && <p className={styles.cardYear}>{year}</p>}
        <p className={styles.cardDesc}>
          <LinesEllipsis
            text={reward.desc}
            maxLine={isTruncated ? 3 : 100}
            ellipsis={
              isTruncated ? (
                <span>
                  ...{' '}
                  <span
                    className={styles.readMoreLink}
                    onClick={() => setTruncated(false)}
                  >
                    {t('read-more')}
                  </span>
                </span>
              ) : (
                ''
              )
            }
            trimRight
            basedOn="letters"
          />
          {!isTruncated && (
            <span
              className={styles.readMoreLink}
              onClick={() => setTruncated(true)}
            >
              {' '}
              {t('read-less')}
            </span>
          )}
        </p>
      </div>
    </div>
  )
}

const AwardsSection = ({ rewardsData = [], t }) => {
  const [showAll, setShowAll] = useState(false)
  const featured = rewardsData.slice(0, 3)
  const rest = rewardsData.slice(3)

  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <Reveal>
          <h2 className={styles.heading}>
            {t('about.new.awards.heading-prefix')} <span>SHIPPOP</span>
          </h2>
          <p className={styles.subtitle}>{t('about.new.awards.subtitle')}</p>
        </Reveal>
        <div className={styles.gridContainer}>
          {featured.map((reward, i) => (
            <div className={styles.gridItem} key={reward.title}>
              <Reveal delay={i * 0.1}>
                <AwardCard reward={reward} t={t} />
              </Reveal>
            </div>
          ))}
        </div>
        {rest.length > 0 && (
          <>
            {showAll && (
              <div className={styles.moreGrid}>
                {rest.map((reward) => (
                  <div className={styles.gridItem} key={reward.title}>
                    <AwardCard reward={reward} t={t} />
                  </div>
                ))}
              </div>
            )}
            <div className={styles.toggleWrap}>
              <button
                type="button"
                className={styles.toggleBtn}
                onClick={() => setShowAll((v) => !v)}
              >
                {showAll
                  ? t('about.new.awards.show-less')
                  : t('about.new.awards.show-all')}
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  )
}

export default AwardsSection
